export interface ITime {
  time: number;
  available: boolean;
}
